export default __webpack_public_path__ + "static/media/beef-burger.64a65255.jpg";